import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Payment} from '../../entities/pay/payment.entity';
import {environment} from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PayService {
  public constructor(
    private readonly http: HttpClient
  ) {
  }

  public getPayments(): Observable<Payment[]> {
    return this.http.get<Payment[]>(`${environment.apiUrl}/manage/pay/payments`);
  }
}
